export default class Analytics {
	constructor(app) {
		this.app = app;

		document.addEventListener('cookie-manager-ready', (e) => {
			//console.debug('submit consent: %o', e.detail.allowedCookies)
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'cookieManager.consent',
				allowedCookies: e.detail.allowedCookies,
			});
		})
}}
